export default __webpack_public_path__ + "static/media/curiel-wall.75287447.png";